import { Component, OnInit, ChangeDetectionStrategy, inject, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

import { UsersService } from '@generated/services/users.service';
import { AuthService } from '@core/services/auth.service';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [ButtonModule, ProgressSpinnerModule],
  templateUrl: './profile.html',
  styleUrl: './profile.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileComponent implements OnInit {
  private usersService = inject(UsersService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  loading = true;
  error = false;
  errorMessage = '';

  ngOnInit() {
    // Получаем профиль из authService
    const userProfile = this.authService.getUserProfile();

    // Проверяем есть ли уже данные пользователя в localStorage
    const userData = this.authService.getUserProfileFromLocalStorage();
    if (userData && userProfile) {
      // Проверяем что userData.id совпадает с authService.getUserProfile().id
      if (userData.id && userData.id === userProfile.id) {
        // Если данные корректны - сразу переходим на главную
        this.router.navigate(['/agents']);
        return;
      }
    }

    // Загружаем данные пользователя
    this.loadUserData();
  }

  private loadUserData() {
    this.loading = true;
    this.error = false;
    this.cdr.markForCheck();

    // Получаем профиль из authService
    const userProfile = this.authService.getUserProfile();

    this.usersService.apiUsersMeGet().subscribe({
      next: (user: any) => {
        // Проверяем что id из API совпадает с id из authService
        if (userProfile?.id && user.id && user.id !== userProfile.id) {
          console.error('User ID mismatch:', { apiUserId: user.id, authUserId: userProfile.id });
          this.loading = false;
          this.error = true;
          this.errorMessage = 'User profile mismatch. Please logout and try again.';
          this.cdr.markForCheck();
          return;
        }

        // Если authService не имеет id, но API вернул user с id, используем его
        if (!userProfile?.id && user.id) {
          console.warn('AuthService has no user ID, but API returned user with ID:', user.id);
        }

        // Сохраняем данные пользователя
        this.authService.saveUserProfileToLocalStorage();
        this.loading = false;

        // Переходим на главную страницу
        this.router.navigate(['/agents']);
      },
      error: (error: any) => {
        console.error('Failed to load user data:', error);
        this.loading = false;
        this.error = true;
        this.errorMessage = 'Failed to load user profile. Please try again.';
        this.cdr.markForCheck();
      }
    });
  }

  retry() {
    this.loadUserData();
  }
}